import { Flex } from '@rebass/grid';
import AppBanner from 'components/Banner/App';
import React from 'react';
import { Coin } from 'store/Coin/types';

import CoinSummary from './CoinSummary';
import MarketData from './MarketData';
import { AppBannerWrapper, Container, MarketDataContainer } from './styles';

interface Props {
  coin: Coin;
}

const Header = (props: Props) => {
  const { coin } = props;

  return (
    <Container>
      <Flex
        flexDirection="column"
        flex="1"
        mr={[0, 0, '10px']}
        mb={['10px', 0]}
      >
        <CoinSummary
          coin={coin}
          flexProps={{
            flex: 1,
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        />
        <AppBannerWrapper mb={[0, '10px', 0]}>
          <AppBanner coinName={coin.name} />
        </AppBannerWrapper>
      </Flex>

      <MarketDataContainer ml={[0, 0, '10px']}>
        <MarketData coin={coin} />
      </MarketDataContainer>
    </Container>
  );
};

export default Header;
